import axios from 'axios';
import get from 'lodash/get';
import log from 'chameleon/ui-stack/utilities/log';
import { getQBCreateAddInfo } from 'legacy-src/queries';

export const getLibraryDataPromise = (subjectId) => {
  const GET_LIBRARY_DATA_URL = `${FYM_BACKEND_URL}/content/api/libraries/for_group/${subjectId}/`;

  return axios.get(GET_LIBRARY_DATA_URL).catch((err) => {
    log('error', err);
  });
};

export const resolveLibraryId = async (libraryId, subjectId) => {
  if (!libraryId) {
    try {
      const libraryDataResponse = await getLibraryDataPromise(subjectId);
      if (libraryDataResponse) {
        return libraryDataResponse.data.id;
      }
      throw new Error(
        `Could not retrieve libraryId for subject "${subjectId}"`,
      );
    } catch (error) {
      log('Could not continue with quiz creation.', error);
      throw new Error(
        `Could not retrieve libraryId for subject "${subjectId}"`,
      );
    }
  }
  return libraryId;
};

/**
 * Get all the data needed for adding a question to quiz:
 * - we need to get the details of the item
 * - we need to get the details of the question stimulus
 * ----- we need to get the details for the stimulus
 * ----- we need to get all the questions of the stimulus.
 * */
const getQuestionWithStimulusData = async (
  subjectId,
  educationPeriod,
  libraryId,
  questionId,
  apolloClient,
) => {
  const responseResult = await apolloClient.query({
    query: getQBCreateAddInfo,
    fetchPolicy: 'network-only',
    variables: {
      subjectId,
      itemIds: [Number.parseInt(questionId, 10)],
      educationPeriod,
    },
  });
  let question = null;
  let stimulus = {};
  let stimulusQuestions = [];
  let newLibraryId = null;

  const loading = get(responseResult, ['loading'], true);
  const qbCreateAdd = get(responseResult, ['data', 'qbCreateAdd'], false);

  if (!loading && qbCreateAdd) {
    [question] = qbCreateAdd.questions;
    question = {
      ...question,
      used_detail: question.used_detail
        ? JSON.parse(question.used_detail)
        : null,
    };

    const stimulusData = qbCreateAdd.stimuli[0];
    if (stimulusData) {
      stimulus = {
        id: Number.parseInt(stimulusData.stimulus_id, 10),
      };
      stimulusQuestions = stimulusData.questions.map((stimQn) => ({
        ...stimQn,
        used_detail: stimQn.used_detail ? JSON.parse(stimQn.used_detail) : null,
      }));
    }
  }

  if (!libraryId) {
    const libraryDataResponse = await getLibraryDataPromise(subjectId);
    newLibraryId = libraryDataResponse && libraryDataResponse.data.id;
  }

  return {
    libraryId: newLibraryId,
    question,
    stimulus,
    stimulusQuestions,
  };
};

export default getQuestionWithStimulusData;
